import React, { forwardRef } from 'react'
import { Link } from 'react-navi'
import { LinkProps } from 'react-navi/dist/types/Link'

export const AdapterLink = forwardRef<HTMLAnchorElement, LinkProps>(
  (props, ref) => <Link ref={ref} {...props} />,
)
